import DataSummary from "../../../../../../packages/design-system/src/DataSummary";
import Spacings from "../../../../../../packages/design-system/src/Spacings";
import * as React from 'react';
export default {
  DataSummary,
  Spacings,
  React
};